"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var picklistService_1 = __importDefault(require("@app/services/picklistService"));
var vue_property_decorator_1 = require("vue-property-decorator");
var DataList_vue_1 = __importDefault(require("@app/components/DataList.vue"));
var OrderStatusService_1 = __importDefault(require("../../services/OrderStatusService"));
var OrderDataService_1 = __importDefault(require("../../services/OrderDataService"));
var DepartmentDataService_1 = __importDefault(require("../../services/DepartmentDataService"));
var PicklistsDataList = /** @class */ (function (_super) {
    __extends(PicklistsDataList, _super);
    function PicklistsDataList() {
        var _this = _super.call(this) || this;
        _this.items = new Array();
        _this.intl = new Intl.DateTimeFormat('de-DE');
        _this.selected = [];
        _this.idSearch = null;
        _this.onlyOnStock = false;
        _this.orderNumberSearch = null;
        _this.scheduledDateFilter = '';
        _this.scheduledDateModal = false;
        _this.filterStatuses = [];
        _this.selectedStatus = null;
        _this.selectedDepartment = null;
        _this.selectedCountryCode = null;
        _this.allCountries = [];
        _this.allDepartments = [];
        _this.dataTableHeaders = [
            {
                text: 'ID',
                value: 'id',
                sortable: true
            },
            {
                text: 'Abteilung',
                value: 'orders[0].department.name',
                sortable: false
            },
            {
                text: 'Zielland',
                value: 'orders[0].shipTo.country_name',
                sortable: false
            },
            {
                text: 'Order Number',
                value: 'order_number',
                sortable: false
            },
            {
                text: 'Order ID',
                value: 'order[0].order_id',
                sortable: true
            },
            {
                text: 'Name',
                value: 'name',
                sortable: false
            },
            {
                text: 'Geplantes Versand-Datum',
                value: 'orders[0].scheduled_shipment_date',
                sortable: false
            },
            {
                text: 'Bestell-Status',
                value: 'orders[0].status.status',
                sortable: false
            },
        ];
        _this.service = picklistService_1.default;
        return _this;
    }
    PicklistsDataList.prototype.printPicklistByIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ids;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ids = this.selected.map(function (picklist) { return picklist.id; });
                        return [4 /*yield*/, picklistService_1.default.printAll(ids)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getItems(this.options)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PicklistsDataList.prototype.getOrderStatuses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, OrderStatusService_1.default.getAllItems()];
                    case 1:
                        _a.filterStatuses = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PicklistsDataList.prototype.created = function () {
        this.getItems(this.options);
        this.getOrderStatuses();
        this.getAllCountries();
        this.getAllDepartments();
    };
    PicklistsDataList.prototype.getAllDepartments = function () {
        var _this = this;
        DepartmentDataService_1.default.getAllItems().then(function (response) {
            _this.allDepartments = response;
        });
    };
    PicklistsDataList.prototype.getAllCountries = function () {
        var _this = this;
        OrderDataService_1.default.getAllCountries().then(function (response) {
            _this.allCountries = response.data;
        });
    };
    PicklistsDataList.prototype.getStatusColor = function (status) {
        var color = 'warning';
        switch (status) {
            case 'processing':
            case 'pending':
            case 'on-hold':
                break;
            case 'complete': // complete
                color = 'green';
                break;
            case 'closed':
                color = 'red';
                break;
            default:
                break;
        }
        return color;
    };
    PicklistsDataList = __decorate([
        vue_property_decorator_1.Component({
            name: 'PicklistsDataList'
        }),
        __metadata("design:paramtypes", [])
    ], PicklistsDataList);
    return PicklistsDataList;
}(DataList_vue_1.default));
exports.default = PicklistsDataList;
